/** Helpers for collection item detail pages (products vs services). */

export function isServiceCollectionSlug(collectionSlug: string): boolean {
  return (collectionSlug || '').trim().toLowerCase() === 'services';
}

export function normalizeInternalPath(path: string): string {
  const raw = (path || '').trim();
  if (!raw) return '';
  const withoutQuery = raw.split('?')[0]?.split('#')[0] ?? raw;
  const withSlash = withoutQuery.startsWith('/') ? withoutQuery : `/${withoutQuery}`;
  return withSlash.replace(/\/+$/, '').toLowerCase() || '/';
}

/** True when `link` points at this collection item’s own detail URL. */
export function isSelfCollectionLink(
  link: string,
  collectionSlug: string,
  itemSlug: string,
): boolean {
  const n = normalizeInternalPath(link);
  if (!n || !collectionSlug || !itemSlug) return false;
  const target = normalizeInternalPath(`/collections/${collectionSlug}/${itemSlug}`);
  return n === target || n.endsWith(target);
}

/** Prefer kontakt/contact pages for service inquiry CTAs. */
export function resolveInquiryPageSlug(pages: Array<{ slug: string }> | undefined): string {
  const list = pages || [];
  const match = list.find((p) => /^(kontakt|contact|anfrage)$/i.test(p.slug));
  return match?.slug || 'kontakt';
}

/** Internal path (starts with /) → open in same tab; otherwise external. */
export function isInternalSiteLink(link: string): boolean {
  const raw = (link || '').trim();
  if (!raw) return false;
  if (raw.startsWith('/')) return true;
  if (raw.startsWith('#')) return true;
  return false;
}
